<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ idselected }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header>
      <b-card-body class="py-0">
        <div>
          <b-row>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Email" label-for="email" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.id"
                    placeholder="Enter email"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.id = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="First Name"
                label-for="firstname"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.firstname"
                    placeholder="Enter first name"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.firstname = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Middle Names"
                label-for="middlenames"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.middlenames"
                    placeholder="Enter middle names"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.middlenames = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Last Name"
                label-for="lastname"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.lastname"
                    placeholder="Enter last name"
                    size="sm"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.lastname = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Title" label-for="title" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.title"
                    placeholder="Enter title"
                    size="sm"
                    list="list-title"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.title = null"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label-cols="12"
                label="Client SL A/C"
                label-size="sm"
              >
                <treeselect
                  placeholder="Select slac..."
                  searchPromptText="Type at least 3 chars..."
                  v-model="item.slac"
                  :multiple="false"
                  :clearable="true"
                  :async="true"
                  :load-options="treeselect_loadSLAC"
                  :show-count="true"
                  :flatten-search-results="true"
                  :disable-branch-nodes="true"
                  :matchKeys="['id']"
                  search-nested
                  :disabled="
                    user.rolename == 'api' || user.rolename == 'client'
                  "
                >
                  <div slot="value-label" slot-scope="{ node }">
                    {{ node.raw.id }}
                  </div>
                </treeselect>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Name Matches"
                label-for="names"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-textarea
                    id="names"
                    v-model="item.names"
                    placeholder="Enter name matches"
                    rows="2"
                    class="smalltextarea"
                  ></b-form-textarea>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.names = ''"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="idselected">
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Created At"
                label-for="created_at"
                label-cols="12"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-datepicker
                      size="sm"
                      v-model="item.created_at"
                      button-only
                      label-help=""
                      locale="en-GB"
                      :disabled="true"
                    ></b-form-datepicker>
                  </b-input-group-prepend>
                  <b-form-input
                    size="sm"
                    id="date"
                    v-model="item.created_at"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.created_at = null"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Created By"
                label-for="created_by"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.created_by"
                    placeholder=""
                    size="sm"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.created_by = ''"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Updated At"
                label-for="updated_at"
                label-cols="12"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-datepicker
                      size="sm"
                      v-model="item.updated_at"
                      button-only
                      label-help=""
                      locale="en-GB"
                      :disabled="true"
                    ></b-form-datepicker>
                  </b-input-group-prepend>
                  <b-form-input
                    size="sm"
                    id="date"
                    v-model="item.updated_at"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.updated_at = null"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group
                label="Updated By"
                label-for="updated_by"
                label-cols="12"
              >
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.updated_by"
                    placeholder=""
                    size="sm"
                    :disabled="true"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="item.updated_by = ''"
                      :disabled="true"
                    >
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
            <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button squared size="sm" variant="primary" @click="saveit">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
      <datalist id="list-title">
        <option v-for="item in options_title" :key="item">{{ item }}</option>
      </datalist>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

export default {
  name: "ClientEmailEdit",
  data() {
    return {
      busy: false,
      item: {
        slac: null,
        names: null,
      },
      options_title: ["MR", "MRS", "MISS", "MS", "DR"],
      options: {
        title: "Client Email",
        icon: "fa fa-envelope",
      },
    };
  },
  methods: {
    async load() {

      let variables = {
        id: this.idselected,
        dateformat: this.dateformat,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query clientemails($id: String, $dateformat: String) {
              clientemails(id: $id, dateformat: $dateformat) {
                id
                slac
                names
                firstname
                middlenames
                lastname
                title
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.clientemails.length > 0) {
          this.item = response.data.clientemails[0];
        }
      } catch (error) {
        console.log(error);
      }

    },
    async saveit() {
      this.busy = true;

      let variables = { rows: [this.cleanit(this.item)] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation saveclientemails(
              $rows: [ClientEmails_input]
              $dateformat: String
            ) {
              saveclientemails(rows: $rows, dateformat: $dateformat) {
                id
                names
                slac
                firstname
                middlenames
                lastname
                title
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style>
</style>